import React, { FC } from 'react';
import { ClassFiltersColumn } from '../Filters.styles';
import { StyledSearchInput } from './SearchInput.styles';

export type SearchInputProps = {
  searchInputLabel?: string;
  onSearchPhraseChange?: (event) => void;
  searchPhrase?: string;
  showSearchInput?: boolean;
};

export const SearchInput: FC<SearchInputProps> = ({
  showSearchInput = false,
  searchInputLabel,
  searchPhrase,
  onSearchPhraseChange,
}) =>
  showSearchInput ? (
    <ClassFiltersColumn>
      <StyledSearchInput
        label={searchInputLabel}
        value={searchPhrase}
        onChange={onSearchPhraseChange}
      />
    </ClassFiltersColumn>
  ) : null;
